// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ETv0K","label":"styles_label__MwbAa","icon":"styles_icon__xr2J2"};